import { HeaderService } from 'src/app/_services/header.service';
import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalController, SegmentValue } from "@ionic/angular";
import { SegmentChangeEventDetail } from "@ionic/core";
import { Subscription } from "rxjs";
import { DictionaryService } from "src/app/dictionary/dictionary.service";
import { GetReportTasksModel } from "src/app/_models/report-task-request.model";
import { DateStiPipe } from "src/app/_pipes/date-sti.pipe";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { HeaderModel } from "../../../_component/header/header.model";
import { RowsLoaderService } from "../../../_services/rows-loader.service";
import { PaginationClientSideOptions } from "../../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../../_component/pagination-client-side/pagination-column.class";
import { ReportFilterModalComponent } from "../report-filter-modal/report-filter-modal.component";
import { ReportTaskViewComponent } from "../report-task-view/report-task-view.component";
import { ReportService } from "../report.service";
import { ReportTask } from "./report-task.model";
import { ReportTaskService } from "./report-task.service";
import { preventSwipeToClose } from 'src/app/_helpers/preventSwipeToClose';

@Component({
  selector: "app-report-task",
  templateUrl: "./report-task.page.html",
  styleUrls: ["./report-task.page.scss"],
})
export class ReportTaskPage implements OnInit {
  constructor(
    public reportServ: ReportService,
    public reportTaskServ: ReportTaskService,
    public dictionaryServ: DictionaryService,
    private userServ: UserService,
    private router: Router,
    public p: ThisPlatform,
    private activatedRoute: ActivatedRoute,
    private modalCtrl: ModalController,
    private headerServ: HeaderService,
  ) {}

  headerInit: HeaderModel = {
    segmentsChangeFunc: ($event) => this.segmentChanged($event),
    segments: [
      {
        name: "REPORT_TASK.FILTR_PERFORMED_BY_ME",
        value: "performedByMe",
        permissionKeys: ["reporttask.mytask"],
      },
      {
        name: "REPORT_TASK.FILTR_ASSIGNMENT_BY_ME",
        value: "assignmentByMe",
        permissionKeys: ["reporttask.mytask"],
      },
      {
        name: "REPORT_TASK.FILTR_ALL",
        value: "all",
        permissionKeys: ["reporttask.alltask"],
      },
    ],
    title: "REPORT_TASK.TASKS",
  };

  segmentValue: SegmentValue = '';
  statusValue: string;
  priorityValue: string;
  componentRef: any = ReportTaskViewComponent;
  segmentsArray = [];
  actualSubscription: Subscription;

  columnsDefinition: PaginationColumn[] = [
    {
      name: "createdAt",
      displayName: "REPORT_TASK.DATE",
      size: 2,
      sortable: true,
    },
    {
      name: "number",
      displayName: "REPORT_TASK.REPORT",
      size: 3,
      sortable: true,
      sortableMobile: false,
      colValue: (row) => {
        return row.report.title;
      },
    },
    {
      name: "assignmentBy",
      displayName: "REPORT_TASK.TASK_FROM",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.assignmentBy.firstName + row.assignmentBy.lastName;
      },
    },
    {
      name: "performedBy",
      displayName: "REPORT_TASK.TASK_TO",
      size: 2,
      sortable: true,
      colValue: (row) => {
        return row.performedBy.firstName + row.performedBy.lastName;
      },
    },
    {
      name: "status",
      displayName: "REPORT_TASK.STATUS",
      size: 2,
      sortable: true,
    },
    {
      name: "priority",
      displayName: "REPORT_TASK.PRIORITY",
      size: 2,
      sortable: true,
      colValue: (ref) => {
        return ref.report.priority;
      },
    },
    {
      name: "",
      displayName: "",
      size: 1,
      sortable: false,
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    gridColumnsCount: 14,
    mobileViewBreakPoint: 1250,
    headerStickyPosition: 54,
    mobileFilterButton: true,
  };

  rowsLoader: RowsLoaderService;

  reportTasksFilter: ReportTask[] = new Array();

  showLoader = true;

  @ViewChild("searchBar")
  searchBar;

  async ngOnInit() {
    await this.userServ.getPermision();

    this.headerInit.segments.forEach((segment) => {
      if (this.userServ.hasRoles(segment.permissionKeys)) {
        this.segmentsArray.push(segment.value);
      }
    });
    this.activatedRoute.queryParamMap.subscribe((p) => {
      const page = p.get("section");
      if (page && this.segmentsArray.filter((el) => el === page).length > 0) {
        this.segmentValue = page;
        this.refreshView();
      } else {
        this.segmentValue = this.segmentsArray[0];
        this.setQueryParam();
        this.headerServ.setHeaderInit(this.headerInit);
      }
    });
  }
  
  ionViewWillEnter() {
    this.headerInit.activeSegment = this.segmentValue + '';
    this.headerServ.setHeaderInit(this.headerInit);
    this.actualSubscription = this.reportServ.filterDetailsSubject.subscribe(
      () => {
        this.refreshView();
      }
    );
  }

  // aktualnie nie jest używana
  onFilterChange() {
    this.refreshView();
  }

  refreshView() {
    let requestData: GetReportTasksModel;
    this.showLoader = true;
    this.reportServ.filterDetailsShowLoader = true;

    requestData = {
      status:
        this.reportServ.reportFilter.statusValue == "null"
          ? null
          : this.reportServ.reportFilter.statusValue,
      priority:
        this.reportServ.reportFilter.priorityValue == "null"
          ? null
          : this.reportServ.reportFilter.priorityValue,
    };

    if (!this.segmentValue || this.segmentValue === "performedByMe") {
      requestData.performedBy = this.userServ.userStorage.id;
    } else if (this.segmentValue === "assignmentByMe") {
      requestData.assignmentBy = this.userServ.userStorage.id;
    }

    this.reportTaskServ
      .getReportTasks(requestData)
      .subscribe((reportTasks: ReportTask[]) => {
        this.reportTaskServ.reportTasks = this.reportTasksFilter = reportTasks;
        this.rowsLoaderInit();
      });
  }

  setQueryParam(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        section: this.segmentValue,
      },
    });
  }

  onFilterPriority(priority) {
    if (priority.length !== 0) {
      this.reportServ.reportFilter.priority = priority ? priority : null;
      this.reportServ.reportFilter.priorityValue = priority
        ? priority.value.toString()
        : null;
    } else {
      this.reportServ.reportFilter.priority = null;
      this.reportServ.reportFilter.priorityValue = "null";
    }
    this.refreshView();
  }

  onFilterStatus(status) {
    if (status.length !== 0) {
      this.reportServ.reportFilter.status = status ? status : null;
      this.reportServ.reportFilter.statusValue = status
        ? status.value.toString()
        : null;
    } else {
      this.reportServ.reportFilter.statusValue = "null";
      this.reportServ.reportFilter.status = null;
    }
    this.refreshView();
  }

  onChangeSearch(data) {
    this.rowsLoaderInit();
  }

  getStatusName(statusId: number) {
    if (this.dictionaryServ.reportTaskStatusValues) {
      return this.dictionaryServ.reportTaskStatusValues.find(
        (b) => b.value === statusId
      ).key;
    }
  }

  segmentChanged(event: CustomEvent<SegmentChangeEventDetail>) {
    this.segmentValue = event.detail.value;
    this.setQueryParam();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      this.showLoader = false;
      this.reportServ.filterDetailsShowLoader = false;
      if (this.searchBar.ngModel && this.searchBar.ngModel.length > 0) {
        this.reportTasksFilter = this.reportTaskServ.reportTasks.filter((s) =>
          (
            new DateStiPipe(this.userServ).transform(s.createdAt) +
            " " +
            s.report.title +
            " " +
            s.assignmentBy.firstName +
            " " +
            s.assignmentBy.lastName +
            " " +
            s.performedBy.firstName +
            " " +
            s.performedBy.lastName +
            " " +
            s.description
          )
            .toUpperCase()
            .includes(this.searchBar.ngModel.toUpperCase())
        );
      } else {
        this.reportTasksFilter = this.reportTaskServ.reportTasks;
      }

      this.rowsLoader.init(this.reportTasksFilter);
    }
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
      component: ReportFilterModalComponent,
      componentProps: {
        page: "report-task",
      },
      canDismiss: preventSwipeToClose,
      cssClass: "add-edit-modal mobile-filter__modal-container",
    });
    modal.present();
  }

  ionViewWillLeave() {
    this.reportServ.reportFilter = {
      statusValue: "null",
      status: null,
      priorityValue: "null",
      priority: null,
    };

    this.actualSubscription.unsubscribe();
  }
}
